import axios from 'axios'

/**
 * @desc Fetch all Rebates for specified supplier
 *
 * @param {Integer} supplierId
 */
export const fetchRebates = (supplierId) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/rebate-rules`)
    .then((res) => res.data)

/**
 * @desc Create new Rebate for specified supplier
 *
 * @param {Integer} supplierId
 * @param {Object} rebate
 */
export const createRebate = (supplierId, rebate) =>
  axios
    .post(`/authenticated/supplier/${supplierId}/rebate-rules`, rebate)
    .then((res) => res.data)

/**
 * @desc Update Rebate for specified supplier
 *
 * @param {Integer} supplierId
 * @param {Integer} supplierRebateRuleId
 * @param {Object} rebate
 */
export const updateRebate = (supplierId, supplierRebateId, rebate) =>
  axios
    .put(
      `/authenticated/supplier/${supplierId}/rebate-rules/${supplierRebateId}`,
      rebate
    )
    .then((res) => res.data)

/**
 * @desc Delete Rebate for specified supplier
 *
 * @param {Integer} supplierId
 * @param {Integer} supplierRebateRuleId
 */
export const deleteRebate = (supplierId, supplierRebateId) =>
  axios
    .delete(
      `/authenticated/supplier/${supplierId}/rebate-rules/${supplierRebateId}`
    )
    .then((res) => res.data)
